import React from "react";
import "../css/site.css";
import gallery_data from "../data/gallery.json";
import Photo from './Photo.js'
import PhotoPopup from "./photoPopup.js";

import { useState } from "react";

export default function Gallery() {


  const [open, setOpen] = useState(false)
  const [image, setImage] = useState({})
  const [index, setIndex] = useState(0)
  const [tag, setTag] = useState("")

  const toggleOpen = () => {
    setOpen(!open)
  }

  const selectImage = (data, index, tag) => {
    setImage(data);
    setIndex(index);
    setTag(tag);
    toggleOpen();
  }

  const next = (e) => {
    e.stopPropagation();
    let gallery = gallery_data;
    let nextIndex = (index + 1) % gallery.length;
    let nextImage = gallery[nextIndex];
    setImage(nextImage);
    setIndex(nextIndex);
  }

  const prev = (e) => {
    e.stopPropagation();
    let gallery = gallery_data;
    let nextIndex = (index - 1 + gallery.length) % gallery.length;
    let nextImage = gallery[nextIndex];
    setImage(nextImage);
    setIndex(nextIndex);
  }

  return (
    <section className="small-section">
      <h1>Gallery</h1>
      <p>For more examples, check out my instagram: <a className='card-link' href="https://www.instagram.com/dango.ploof/">@dango.ploof</a></p>
      <div className="card-row">
        {gallery_data.map((item, index) => (
          <Photo key={item.title} data={item} tag={"gallery"} index={index} showDate={true} selectImage={selectImage}/>
        ))}
      </div>

      {open &&
        <PhotoPopup showDate={true} data={image} toggleOpen={toggleOpen} next={next} prev={prev}/>
      }
    </section>
  );
}
